__turbopack_context__.v({
  "brand": "AppLoader-module-scss-module__Ej0Qva__brand",
  "contentHidden": "AppLoader-module-scss-module__Ej0Qva__contentHidden",
  "contentVisible": "AppLoader-module-scss-module__Ej0Qva__contentVisible",
  "fadeIn": "AppLoader-module-scss-module__Ej0Qva__fadeIn",
  "logoWrap": "AppLoader-module-scss-module__Ej0Qva__logoWrap",
  "overlay": "AppLoader-module-scss-module__Ej0Qva__overlay",
  "shimmer": "AppLoader-module-scss-module__Ej0Qva__shimmer",
  "spinner": "AppLoader-module-scss-module__Ej0Qva__spinner",
});
